import React, { useState, useEffect } from "react";
import { useSnackbar } from 'notistack';
import { withRouter } from "react-router";
import moment from "moment";
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Grid, Button, TextField, Dialog, DialogContent, DialogTitle, DialogActions, Tooltip, CircularProgress, Checkbox,FormControl,FormLabel ,RadioGroup,FormControlLabel,Radio} from '@material-ui/core';
import { Pagination, STableLoader, FilterComponent, PageLoader, EmptyCollection, DeletePopUp } from '../../shared_elements';
import { TechSpecsNav } from '../../elements'
import { AssetInfo } from '../components'
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { globalGetService, globalPutService, globalPostService, globalDeleteService, globalExportService } from '../../../globalServices';
import { checkApiStatus, checkPermission } from '../../utils_v2';
import useAssetInfo from '../hooks/useAssetInfo';
import { downloadFileType } from '../../../utils';
import { assetTypeValues, backendDateFormat, displayDateFormat, fieldDateFormat } from '../../../constants'
import ExportMenu from "../../shared_elements/ExportMenu";
import { trackActivity } from "../../../utils/mixpanel";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import { Autocomplete } from "@material-ui/lab";
import AddIcon from '@material-ui/icons/Add';
import { usePageTitleOffset } from '../../elements/CollapsibleSideNav';

const RegHistoryHd = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Action(s)</TableCell>
                <TableCell>Registration</TableCell>
                <TableCell>Registration Date</TableCell>
                <TableCell>De-Registration Date</TableCell>
                <TableCell>Country</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Temporary</TableCell>
                <TableCell>Remarks</TableCell>
            </TableRow>
        </TableHead>
    )
}
const RegHistoryList = ({ item, onEdit, onDelete, index }) => {
    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field],
        });
    };
    return (
        <TableRow>
            <TableCell align='left'>
                <ul className="list-inline">
                    {checkPermission('technical_specs', 'registration_history', 'U') ?
                        <li className="list-inline-item hover-inline" onClick={onEdit}>
                            <Tooltip title='Edit' arrow><EditIcon color="primary" fontSize="small" /></Tooltip>
                        </li> : null
                    }
                    {checkPermission('technical_specs', 'registration_history', 'D') ?
                        <li className="list-inline-item hover-inline " onClick={onDelete}>
                            <Tooltip title='Delete' arrow><DeleteOutlineIcon color="secondary" fontSize="small" /></Tooltip>
                        </li> : null
                    }
                </ul>
            </TableCell>
            <TableCell>
                {item?.registration && item?.registration?.length > 30 ? (
                    <div style={{ maxWidth: '500px' }} >
                        {showMore[item?.field] && showMore[item?.field] ? (
                            <span> {item?.registration}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  >  less </a>
                            </span>
                        ) : (
                            <span> {item.registration.substring(0, 25)}
                                <a href='#' style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }}  > ..more </a>
                            </span>
                        )}
                    </div>
                ) :
                    <div>{item.registration || '--'}</div>
                }
            </TableCell>
            <TableCell>
            {item?.registration_date ? moment(item.registration_date).format(displayDateFormat) :'--'}
            </TableCell>
            <TableCell>
                {item?.deregistration_date ? moment(item.deregistration_date).format(displayDateFormat) :'--'}
            </TableCell>
            <TableCell>
                {item?.country || '--'}
            </TableCell>
             <TableCell>{item?.status?.label||'--'}</TableCell>
            <TableCell>
                {item?.temporary?'Yes':'No'}
            </TableCell>
            <TableCell>
                {item?.remarks && item?.remarks?.length > 30 ? (
                    <div style={{ width: '200px' }}>
                        {showMore[item?.field] ? (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
                            </span>
                        ) : (
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
                                <a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
                            </span>
                        )}
                    </div>
                ) : (
                    <div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
                )}
            </TableCell>
        </TableRow>
    )
}
const AddEditRegHistory = ({ params, addEditRegHistory, toggleModalFn, getResponseBack, assetInfoData, setCurrentPage }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [regHistory, setRegHistory] = useState({...addEditRegHistory.data,status : addEditRegHistory?.data?.status ?addEditRegHistory?.data?.status: {value :1,label :"Active"}});
    const [error, setError] = useState({});
    const onAddEditRegHistory = () => {
        let validationInputs = {}
        validationInputs= {
            ...validationInputs,
            registration:regHistory?.registration ? '':'Pease enter Registration number',
            country:regHistory?.country ? '':'Pease enter Country'
        }
        if(regHistory?.registration_date && !moment(regHistory?.registration_date).isValid()){
            validationInputs ={
                ...validationInputs,
                registration_date:'Please enter valid Registration Date'
            }
        }
        if (regHistory?.deregistration_date && !moment(regHistory?.deregistration_date).isValid()) {
            validationInputs = {
                ...validationInputs,
                deregistration_date: 'Please enter valid De-Registration Date'
            }
        }
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === '' })) {
            setLoading(true)
            if (regHistory.id) {
                globalPutService(`console/${params.type}/${params.aircraft_slug}/registration-history/${regHistory.id}/`,regHistory)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            toggleModalFn();
                            getResponseBack();
                            setCurrentPage(1);
                        }
                        setLoading(false)
                    })
            } else {
                globalPostService(`console/${params.type}/${params.aircraft_slug}/registration-history/`, regHistory)
                    .then(response => {
                        if (checkApiStatus(response)) {
                            enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                            trackActivity('Console Management', {data:JSON.stringify(regHistory), page_title: 'Registration History', asset_type: assetTypeValues[assetInfoData?.asset_type.type].label, asset_name: assetInfoData?.serial_number, event_type: 'Item Added', event_desc: 'Added Registration History data' });
                            toggleModalFn();
                            getResponseBack();
                            setCurrentPage(1);
                        }
                        setLoading(false)
                    })
            }
        } else {
            setError(validationInputs)

        }
    }
    const onFieldChange = (key, value) => {
        setRegHistory({
            ...regHistory,
            [key]: value
        })
    }

    return (
        <Dialog
            open={addEditRegHistory.modal}
            onClose={toggleModalFn}
            className='console-management-modal'
            maxWidth="md"
        >
            <DialogTitle id="scroll-dialog-title">
                {addEditRegHistory.data.id ? 'Edit ' : 'Add '} Registration History
            </DialogTitle>
            <DialogContent dividers={true}>
                <div style={{ width: '500px' }}>
                    <Grid container spacing={1}>
                        <Grid item md={6}>
                            <TextField
                                required
                                name='registration'
                                label='Registration'
                                value={regHistory?.registration || ''}
                                fullWidth
                                inputProps={{maxLength: 50}}
                                margin="normal"
                                error={Boolean(error?.registration)}
                                helperText={error?.registration || ''}
                                onChange={(e) => onFieldChange('registration', e.target.value)}
                                onFocus={() => setError({ ...error, registration: '' })}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="registration_date"
                                    fullWidth
                                    format={fieldDateFormat}
                                    label='Registration Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={regHistory?.registration_date || null}
                                    onChange={(data, value) =>{ onFieldChange('registration_date', data ? moment(data).format(backendDateFormat) : null); setError({...error,registration_date:''})}}
                                    inputVariant="outlined"
                                    error={error.registration_date ? true : false}
                                    helperText={error.registration_date || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={6}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    id="deregistration_date"
                                    fullWidth
                                    format={fieldDateFormat}
                                    label='De-Registration Date'
                                    InputLabelProps={{ shrink: true }}
                                    value={regHistory?.deregistration_date || null}
                                    onChange={(data, value) => {onFieldChange('deregistration_date', data ? moment(data).format(backendDateFormat) : null);setError({...error,deregistration_date:''})}}
                                    inputVariant="outlined"
                                    error={error.deregistration_date ? true : false}
                                    helperText={error.deregistration_date || ''}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={6}>
                            <TextField
                                required
                                name='country'
                                label='Country'
                                value={regHistory?.country || ''}
                                fullWidth
                                margin="normal"
                                error={Boolean(error?.country)}
                                helperText={error?.country || ''}
                                onChange={(e) => onFieldChange('country', e.target.value)}
                                onFocus={() => setError({ ...error, country: '' })}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={12} >
                            <TextField
                                name='remarks'
                                label='Remarks'
                                value={regHistory?.remarks || ''}
                                fullWidth
                                margin="normal"
                                multiline
                                rows={3}
                                inputProps={{ maxLength: 255 }}
                                onChange={(e) => onFieldChange('remarks', e.target.value)}
                                InputLabelProps={{ shrink: true }}
                                variant='outlined'
                            />
                        </Grid>
                        <Grid item md={12} style={{padding :"0px 4px"}}>
                            <FormControl component="fieldset" margin="normal">
                                <FormLabel className="MuiInputLabel-shrink" component="label" >Status</FormLabel>
                                <RadioGroup row name="status" defaultValue={1} >
                                    <FormControlLabel value={regHistory?.status?.value} control={<Radio color="primary" size="small" onChange={() => onFieldChange('status',{value : 1,label :"Active"})} checked={regHistory?.status?.value === 1} />} label="Active" />
                                    <FormControlLabel value={regHistory?.status?.value} control={<Radio color="primary" size="small" onChange={() => onFieldChange('status',{value : 2,label :"Expire"})} checked={regHistory?.status?.value === 2} />} label="Expire" />
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                       
                        <Grid item md={6} >
                            <div style={{color:"#474747", fontFamily:"Conv_IBMPlexSans-Medium", fontSize:'13px'}}>
                            <Checkbox style={{marginLeft:"-12px"}} checked={regHistory.temporary} onChange={(e) => { onFieldChange('temporary', e.target.checked) }} color="primary" size="small" />
                            Temporary
                            </div>
                            {/* <Autocomplete
                                options={['Yes',No]}
                                getOptionLabel={option => option || ''}
                                id="is_temp"
                                disableClearable={true}
                                value={regHistory?.is_temp || null}
                                onChange={(e, value) => onFieldChange('is_temp', value)}
                                renderInput={params => <TextField {...params} label={'Temporary'} error={error?.is_temp || ''} helperText={error?.is_temp || ''} margin="normal" required fullWidth InputLabelProps={{ shrink: true }} variant='outlined' />}
                                onFocus={() => setError({ ...error, is_temp: '' })}
                            /> */}
                        </Grid>
                       
                        </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button disabled={isLoading} onClick={toggleModalFn} color='primary' size='small' variant='outlined'>Cancel</Button>
                <Button disabled={isLoading} onClick={onAddEditRegHistory} color='primary' size='small' variant='contained'>
                    {isLoading ? <CircularProgress size={24} /> : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const RegistrationCf = ({ params }) => {
    const navTitleOffset = usePageTitleOffset('techSpecsNavCollapsed');
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [filter, setFilter] = useState({});
    const [regHistory, setRegHistory] = useState([]);
    const [addEditRegHistory, setAddEditRegHistory] = useState({ modal: false, data: null });
    const [deleteRegHistory, setDeleteRegHistory] = useState({ modal: false, data: null });
    const { assetInfoData, assetSkeletonLoader, refreshAssetInfo } = useAssetInfo(params.type, params.aircraft_slug);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {
        getRegHistory({per_page:50}, 'skeletonLoader');
    }, []);
    const getRegHistory = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`console/${params.type}/${params.aircraft_slug}/registration-history/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setRegHistory(response.data.data)
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }
    const onDeleteRegHistory = () => {
        setLoading(true);
        globalDeleteService(`console/${params.type}/${params.aircraft_slug}/registration-history/${deleteRegHistory.data.id}/`)
            .then(response => {
                if (checkApiStatus(response)) {
                    enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                    setDeleteRegHistory({ modal: false, data: null });
                    getRegHistory({per_page:regHistory?.pagination?.per_page}, 'pageLoader');
                    setCurrentPage(1);
                }
                setLoading(false);
            })
    }
    const onExportReport = (extension) => {
        setLoading(true);
        globalExportService(`console/${params.type}/${params.aircraft_slug}/registration-history/`, { export: extension })
            .then(response => {
                downloadFileType(response, `${assetInfoData.serial_number}-${params?.type} Registration History ${moment().format(fieldDateFormat)}`, extension)
                setLoading(false);
            })
    }
    return (
        <section className="asset-tech-specs">
            <AssetInfo assetInfoData={assetInfoData} skeletonLoader={assetSkeletonLoader} getResponseBack={refreshAssetInfo} />
            <Paper elevation={0} className="tech-specs-card console-paper" style={{ height: `${window.innerHeight - 162}px` }}>
                <TechSpecsNav />
                <div className="tech-specs-content" >
                    {skeletonLoader ? <STableLoader count={6} /> :
                        <div style={{ padding: '0px 10px' }}>

                            <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px' }}>
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item md={9}></Grid>
                                    <Grid item md={3}>
                                        <ul className="list-inline flex-centered" style={{ float: 'right' }}>
                                             {regHistory?.list?.length && checkPermission('technical_specs', 'registration_history', 'EXP') ?
                                                <li className='list-inline-item'>
                                                    <ExportMenu
                                                        files={[{ title: 'Excel', extension: 'xlsx' },]}
                                                        exportReportFn={(file) => onExportReport(file.extension)}
                                                        />
                                                </li> : null
                                            }
                                            {checkPermission('technical_specs', 'registration_history', 'C') ?
                                                <li className="list-inline-item">
                                                    <Button onClick={() => setAddEditRegHistory({ modal: true, mode: 'add', data: {} })} color='primary' size='small' variant="contained"> <AddIcon style={{ fontSize: '1.15rem' }} />Add</Button>
                                                </li> : null
                                            }
                                        </ul>
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper square>
                                <div style={{height:`${(window.innerHeight -  (regHistory?.list?.length ? 275 : 225)) - navTitleOffset}px`,overflow:'auto', marginTop: "3px"}}>
                                <Table className='mui-table-format' stickyHeader>
                                    <RegHistoryHd />
                                    <TableBody>
                                        {
                                            regHistory?.list?.map((item, index) =>
                                                <RegHistoryList
                                                    key={index}
                                                    item={item}
                                                    index={(currentPage - 1) * itemsPerPage + index + 1} onEdit={() => setAddEditRegHistory({ modal: true, mode: 'edit', data: item })}
                                                    onDelete={() => setDeleteRegHistory({ modal: true, data: item })}
                                                />)
                                        }
                                    </TableBody>
                                </Table>
                                {!regHistory?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                                </div>
                            </Paper>
                            <Paper square>
                                <Pagination
                                    pagination={regHistory.pagination}
                                    onChangePage={(event, newPage) => { setCurrentPage(newPage + 1); getRegHistory({ ...filter, page: newPage + 1, per_page: itemsPerPage }, 'pageLoader') }}
                                    onChangeRowsPerPage={(event) => { setItemsPerPage(event.target.value); setCurrentPage(1); getRegHistory({ ...filter, page: 1, per_page: event.target.value }, 'pageLoader') }}
                                />
                            </Paper>
                        </div>
                    }
                </div>
                {addEditRegHistory.modal ?
                    <AddEditRegHistory
                        params={params}
                        setCurrentPage={setCurrentPage}
                        assetInfoData={assetInfoData}
                        addEditRegHistory={addEditRegHistory}
                        toggleModalFn={() => setAddEditRegHistory({ modal: false, data: null })}
                        getResponseBack={() => getRegHistory({per_page:regHistory?.pagination?.per_page}, 'pageLoader')}
                    /> : null
                }
                {deleteRegHistory.modal ?
                    <DeletePopUp
                        modal={deleteRegHistory.modal}
                        title='Delete Registration History'
                        content={`Are you sure, you want to Delete?`}
                        toggleModalFn={() => setDeleteRegHistory({ modal: false, data: null })}
                        deleteRecordFn={onDeleteRegHistory}
                    /> : null
                }
                {isLoading ? <PageLoader /> : null}
            </Paper>
        </section>

    )
}
export default withRouter(RegistrationCf);
